module.exports = "https://static.wagwalking.com/_next/static/images/walk-2-eb0a8f00e502d514db9390ccc68fe2c5.svg";